<template>
	<b-modal
      :no-close-on-backdrop="true"
      size="lg"
      style="margin: 0.5em 0 0.5em 0;"
      :visible="visible"
      @change="change"
      @shown="show"
      @ok="ok"
      @cancel="cancel">
		<template v-slot:modal-title><h4 style="color: rgb(131, 186, 35); margin-bottom: 0;">Enter Data For
			{{ ndcNumber }}</h4></template>
		<div class="card">
			<div class="card-header pt-2 pb-2" style="min-height: 48px">
				<span>Line Item Info</span>
			</div>
      <ul>
        <li v-for="flashMessage in flashMessages" :key="flashMessages.message" class="alert-warning">
          {{ flashMessage.message }}
        </li>
      </ul>
			<div class="card-body">
				<ValidationObserver ref="observer" v-slot="{handleSubmit}">
					<b-form @submit.stop.prevent="handleSubmit(ok)">
						<!--					<FeedbackPanel></FeedbackPanel>-->
						<div class="row mb-1">
							<div class="col-4">
								<strong>Source Number</strong>
								<ValidationProvider v-slot="v" ref="sourceNumber">
									<b-form-input
											class="job-field
											form-control"
											v-model="sourceNumber"
									/>
								</ValidationProvider>
							</div>
							<div class="col-8">
								<strong>Source</strong>
								<ValidationProvider v-slot="v" ref="source">
									<v-select
											:options="sourceOptions"
											v-model="source"
									></v-select>
								</ValidationProvider>
							</div>
						</div>
						<div class="row mb-1">
							<div class="col-4">
								<strong>Lot Number</strong>
								<ValidationProvider v-slot="v" ref="lotNumber">
									<b-form-input
											class="job-field form-control"
											v-model="lotNumber"
									/>
								</ValidationProvider>
							</div>
							<div class="col-8">
								<strong>Cause</strong>
								<ValidationProvider v-slot="v" ref="cause">
									<v-select
											:options="causeOptions"
											v-model="cause"
									></v-select>
								</ValidationProvider>
							</div>
						</div>
						<hr/>
						<div class="row mb-1">
							<div v-if="!ndcNumber.includes('**')" class="col-3">
								<div><strong>Pack Qty</strong></div>
								<ValidationProvider v-slot="v" ref="packQuantity">
									<b-form-input
											id="pack-qty"
											class="job-field form-control"
											v-model="packQuantity"
									/>
								</ValidationProvider>
							</div>
							<div class="col-6">
								<strong>Type</strong>
								<ValidationProvider v-slot="v" ref="packQuantityUoM">
									<v-select
											:options="packQtyUomValueList"
											v-model="packQuantityUoM"
									></v-select>
								</ValidationProvider>
							</div>
							<div class="col-3">
								<div v-if="isBulk"><strong>% Purity</strong></div>
								<div v-else><strong>% Fill</strong></div>
								<div v-if="isPercentFillStatic" class="job-field">{{ percentFillLookup }}</div>
								<ValidationProvider v-slot="v" ref="percentFill" v-else>
									<b-form-input
											class="job-field form-control"
											v-model="percentFill"
									/>
								</ValidationProvider>
							</div>
						</div>
						<!--Pack_Size-->
						<!--Pack_Size_UoM-->
						<div class="row mb-1">
							<div class="col-3 pr-1">
								<div><strong>Pack Size**</strong></div>
								<ValidationProvider v-slot="v" ref="packSize">
									<b-form-input
											id="pack-size"
											v-if="isBulk"
											class="job-field form-control"
											v-model="packSize"
									/>
									<div v-else class="job-field">
										{{ packSizeLookup }}
									</div>
								</ValidationProvider>
							</div>
							<div class="col-3">
								<strong>UoM</strong>
								<ValidationProvider v-slot="v" ref="packSizeUoM">
									<v-select id="pack-size-uom" v-if="isBulk"
											  :options="dynamicUomValueList"
											  v-model="packSizeUoM"
									></v-select>
									<!--									<b-form-input
                                                          id="pack-size-uom"
                                                          v-else-if="isBulk"
                                                          class="job-field form-control"
                                                          v-model="packSizeUoM"
                                                      />-->
									<div v-else class="job-field ">
										{{ packSizeUoMLookup }}
									</div>
								</ValidationProvider>
							</div>
							<div v-show="hasFactor" class="offset-3 col-3">
								<strong>Converted</strong>
								<div class="job-field ">{{ convertToBase }}</div>
							</div>
						</div>
						<hr/>
						<!--				<div class="row mb-1">
                                  <div class="col-4">
                                    <div><strong>Ordered Qty</strong></div>
                                    <div class="job-field">{{ orderedQtyCalc }}</div>
                                  </div>
                                  <div class="col-8">
                                    <strong>UoM</strong>
                                    <div class="job-field ">{{ packSizeUoM }}</div>
                                  </div>
                                </div>-->
						<hr v-show="showStageUnitConverter || showUnitConverter"/>
						<div class="row mb-1">
							<div class="col-6 card-title" v-show="showUnitConverter">
								<h6 class="mb-2" style="text-decoration: underline">Unit Converter</h6>
								<div class="row">
									<div class="col-6">
										<div><strong>Amt</strong></div>
										<ValidationProvider v-slot="v" ref="bulkPackSize">
											<b-form-input
													id="bulk-blend-pack-size"
													class="job-field form-control"
													v-model="bulkPackSize"
											/>
										</ValidationProvider>
									</div>
									<div class="col-6">
										<strong>UoM</strong>
										<ValidationProvider v-slot="v" ref="bulkPackSizeUoM">
											<v-select
													:options="yiPkgSizeBulkBlendUoMOptions"
													v-model="bulkPackSizeUoM"
											></v-select>
										</ValidationProvider>
									</div>
								</div>
							</div>
							<div class="col-6 card-title" :class="{'converter-divider': showUnitConverter}"
								 v-show="showStageUnitConverter">
								<h6 class="mb-2" style="text-decoration: underline">Stage Converter</h6>
								<div class="row">
									<div class="col-12">
										<div><strong>Stage</strong></div>
										<ValidationProvider
												v-slot="v"
												ref="bulkStage">
											<v-select
													:options="stagesValueList"
													v-model="bulkStage"
											></v-select>
										</ValidationProvider>
									</div>
								</div>
							</div>
						</div>
					</b-form>
				</ValidationObserver>

			</div>
		</div>
	</b-modal>
</template>

<script>

import {ValidationObserver, ValidationProvider} from 'vee-validate';
import feedbackMixin from '../mixins/feedback'
import newLineItemActionMixin from '../mixins/new-line-item-action'
import FeedbackPanel from './FeedbackPanel'
import {EventBus} from "@/event-bus";

export default {
	name: "NewYbLineItem",
	mixins: [feedbackMixin, newLineItemActionMixin],
	components: {
		ValidationProvider,
		ValidationObserver,
		FeedbackPanel
	},
	model: {
		prop: "visible",
		event: "change"
	},
	data() {
		return {
			packSizeLookup: null,
			packSizeUoMLookup: null,
			validationRefs: [
				'sourceNumber',
				'source',
				'lotNumber',
				'cause',
				'packQuantity',
				'packQuantityUoM',
				'percentFill',
				'packSize',
				'packSizeUoM',
				'bulkPackSize',
				'bulkPackSizeUoM',
				'bulkStage'
			],
			showUnitConverter: false,
			showStageUnitConverter: false,
			hasFactor: false,
			packQtyUomValueList: [],
			stagesValueList: [],
			dynamicUomValueList: [],
			sourceNumber: this.initialSourceNumber,
			source: this.initialSource,
			lotNumber: this.initialLotNumber,
			cause: this.initialCause,
			packQuantity: this.initialPackQuantity,
			percentFill: this.initialPercentFill ? this.initialPercentFill : 1,
			packQuantityUoM: this.initialPackQtyUoM,
			packSize: this.initialPackSize,
			packSizeUoM: this.initialPackSizeUoM,
			bulkPackSize: null,
			bulkPackSizeUoM: null,
			bulkStage: null,
			sourceOptions: [
				'',
				'Lab',
				'Manufacturer',
				'Production',
				'Product Development',
				'RD Chemistry',
				'Reject',
				'MTI Analytical',
				'MTI R&D',
				'Customer Return',
				'Analytical',
				'Pharmacy',
				'QC',
				'QA Retains',
				'Damage slip',
				'Samples',
				'Packaging',
				'Customer Returns',
				'OSD',
				'MRD',
				'Warehouse',
				'Distributor',
				'Damage',
				'Practitioner',
				'Stability',
				'Complaints',
				'Researcher',
				'QSDB Reject',
				'QA',
				'Tech Services',
				'Exporter',
				'IDT',
				'Clinical Supply Operations',
				'Chemstore'
			],
			causeOptions: [
				"",
				'Off-Spec',
				'Waste',
				'Testing Complete',
				'Expired',
				'Lab Samples',
				'Complaint',
				'Damage',
				'Reject',
				'O2C',
				'Dispensed',
				'Undispensed/Returned',
				'Undisp./Returned',
				'Terminated',
				'Refused',
				'Discontinued'
			],
			yiPkgSizeBulkBlendChosenStageOptions: [
				''
			],
			yiPkgSizeBulkBlendUoMOptions: [
				'',
				'kg',
				'g',
				'mg',
				'mcg',
			],
      flashMessages: [],
      initialSchedule: null,
      schedule: this.initialSchedule,
		}
	},
	props: {
		initialSource: {
			type: String
		},
		initialSourceNumber: {
			type: String
		},
		initialLotNumber: {
			type: String
		},
    initialSchedule: {
      type: String
    },
		initialCause: {
			type: String
		},
		initialPackQuantity: {
			type: Number
		},
		initialPackQtyUoM: {
			type: String
		},
		initialPackSize: {
			type: Number
		},
		initialPackSizeUoM: {
			type: String
		},
		initialBulkPackSize: {
			type: Number,
		},
		initialBulkPackSizeUoM: {
			type: String
		},
		initialPercentFill: {
			type: Number
		},
		containerId: {
			type: String,
			default: null
		},
		orderedQtyUoMCalc: {
			type: String,
			default: null
		},
		reportingQty: {
			type: Number,
			default: null
		},
		reportingUoM: {
			type: String,
			default: null
		},
		convertToBase: {
			type: String,
			default: null
		},
		visible: {
			type: Boolean,
			default: false
		},
		percentFillLookup: {
			type: Number,
			default: null
		},
		isPercentFillStatic: {
			type: Boolean,
			default: false
		},
		ndcNumber: {
			type: String,
			default: null
		},
		action: {
			type: String
		},
		id: {
			type: String,
			default: null
		}
	},
	methods: {
		getValidationState({dirty, validated, valid = null}) {
			return dirty || validated ? valid : null;
		},
		show() {
			console.log('NDC Number: ' + this.ndcNumber)
      console.log('Schedule: ' + this.initialSchedule)
			this.axios.get('/3ds/api/ndc/lookup/' + this.ndcNumber)
				.then(value => {
					console.log(JSON.stringify(value))
					this.hasFactor = value.data.hasFactor
					this.packQtyUomValueList = value.data.packQtyUoms
					this.showStageUnitConverter = value.data.showStageUnitConverter
					this.showUnitConverter = value.data.showUnitConverter
					this.stagesValueList = value.data.stages
					this.dynamicUomValueList = value.data.uoms
					this.packSizeLookup = value.data.packSizeLookup
					this.packSizeUoMLookup = value.data.packSizeUoMLookup
          this.schedule = value.data.schedule
				})
				.catch(reason => {
					console.error(JSON.stringify(reason))
				})
		},
		cancel() {
			let that = this
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider && validationProvider.flags.dirty) {
					that[value] = validationProvider.initialValue
					validationProvider.reset()
				}
			})
			this.$emit('canceled')
		},
		ok(event) {
      console.log('Trigger okay: ' + this.ndcNumber)
      if (!this.validateFields()) {
        console.log("Failed validate fields")
        event.preventDefault();
        return;
      }

			if (this.action === this.newLineItemAction.NEW) {
				console.log('Creating line item')
				this.createNewLineItem()
			} else if (this.action === this.newLineItemAction.DUP) {
				console.log('Duplicating line item')
				this.duplicateLineItem()
			} else if (this.action === this.newLineItemAction.EDIT) {
				console.log('Editing line item')
				this.editNewLineItem()
			}
		},
		createNewLineItem() {
			let payload = {}
			let that = this

			payload.user = this.username
			payload.initial = {}
			payload.initial.ndc = this.ndcNumber || null
			payload.initial.cause = this.initialCause || null
			payload.initial.lotNumber = this.initialLotNumber || null
			payload.initial.source = this.initialSource || null
			payload.initial.sourceNumber = this.initialSourceNumber || null
			payload.initial.packQuantity = this.initialPackQuantity || null
			payload.initial.packQuantityUoM = this.initialPackQtyUoM || null
			payload.initial.packSize = this.initialPackSize || null
			payload.initial.packSizeUoM = this.initialPackSizeUoM || null
			payload.initial.percentFill = this.initialPercentFill || null
			payload.initial.bulkPackSize = this.bulkPackSize || null
			payload.initial.bulkPackSizeUoM = this.bulkPackSizeUoM || null

			payload["packQuantity"] = this.packQuantity
			payload["packSizeUoM"] = this.packSizeUoM
			payload["percentFill"] = this.percentFill
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider && validationProvider.flags.dirty) {
					payload[value] = that[value]
				}
			})
			payload["ndc"] = this.ndcNumber
			payload["containerId"] = this.containerId
			this.axios.post('/3ds/api/yb-line-item/new', payload)
				.then(value => {
					console.log(JSON.stringify(value))
					EventBus.$emit('line-item-created', {
						recordId: value.data.recordId
					})
				})
				.catch(reason => {
					console.error(JSON.stringify(reason))
					this.cancel()
				})
		},
		duplicateLineItem() {
			let payload = {}
			let that = this

			payload.user = this.username
			payload.initial = {}
			payload.initial.ndc = this.ndcNumber || null
			payload.initial.cause = this.initialCause || null
			payload.initial.lotNumber = this.initialLotNumber || null
			payload.initial.source = this.initialSource || null
			payload.initial.sourceNumber = this.initialSourceNumber || null
			payload.initial.packQuantity = this.initialPackQuantity || null
			payload.initial.packQuantityUoM = this.initialPackQtyUoM || null
			payload.initial.packSize = this.initialPackSize || null
			payload.initial.packSizeUoM = this.initialPackSizeUoM || null
			payload.initial.percentFill = this.initialPercentFill || null
			payload.initial.bulkPackSize = this.bulkPackSize || null
			payload.initial.bulkPackSizeUoM = this.bulkPackSizeUoM || null

			payload["ndc"] = this.ndcNumber
			payload["containerId"] = this.containerId
			payload["source"] = this.source
			payload["cause"] = this.cause
			payload["packSize"] = this.packSize
			payload["packSizeUoM"] = this.packSizeUoM
			payload["percentFill"] = this.percentFill
			payload["packQuantity"] = this.ndcNumber.includes('**') ? 1 : this.packQuantity
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider && validationProvider.flags.dirty) {
					payload[value] = that[value]
				}
			})
			payload["ndc"] = this.ndcNumber
			payload["containerId"] = this.containerId
			this.axios.post('/3ds/api/yb-line-item/new', payload)
				.then(value => {
					console.log(JSON.stringify(value))
					EventBus.$emit('line-item-created', {
						recordId: value.data.recordId
					})
				})
				.catch(reason => {
					console.error(JSON.stringify(reason))
					this.cancel()
				})
		},
		editNewLineItem() {
			let payload = {}
			let that = this

			payload.user = this.username
			payload.initial = {}
			payload.initial.ndc = this.ndcNumber || null
			payload.initial.cause = this.initialCause || null
			payload.initial.lotNumber = this.initialLotNumber || null
			payload.initial.source = this.initialSource || null
			payload.initial.sourceNumber = this.initialSourceNumber || null
			payload.initial.packQuantity = this.initialPackQuantity || null
			payload.initial.packQuantityUoM = this.initialPackQtyUoM || null
			payload.initial.packSize = this.initialPackSize || null
			payload.initial.packSizeUoM = this.initialPackSizeUoM || null
			payload.initial.percentFill = this.initialPercentFill || null
			payload.initial.bulkPackSize = this.bulkPackSize || null
			payload.initial.bulkPackSizeUoM = this.bulkPackSizeUoM || null

			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider && validationProvider.flags.dirty) {
					payload[value] = that[value]
				}
			})
			payload["id"] = this.id
			payload["ndc"] = this.ndcNumber
			payload["containerId"] = this.containerId
			payload["percentFill"] = this.percentFill
			this.axios.patch(`/3ds/api/yb-line-item/edit/${this.id}`, payload)
				.then(value => {
					console.log(JSON.stringify(value))
					EventBus.$emit('line-item-edited')
				})
				.catch(reason => {
					console.error(JSON.stringify(reason))
				})
		},
		change(visible) {
			this.$emit("change", visible);
      this.flashMessages = [];
		},
    validateFields: function () {
      console.log("Validate NewLineItem")

      if (this.bulkPackSize != null && this.bulkPackSize != "" && this.bulkPackSizeUoM != null && this.bulkPackSizeUoM != "") {
        return true;
      }

      this.flashMessages = [];
      // From containers, the data is provided in initial schedule.  From line item, it's in schedule.
      console.log("initial schedule", this.initialSchedule);
      console.log("schedule", this.schedule);
      const ndaSchedule = this.schedule || this.initialSchedule;
      const packQuantity = this.packQuantity || this.initialPackQuantity;
      console.log("ndsSchedule", ndaSchedule);
      const localUOM = this.packSizeUoM || ""
      const restrictedSchedules = ["1", "1n", "2", "2n", "3", "3n", "4", "4n", "5", "5n", "lc", "nc"];
      const restrictedUoMs = ["u", "k", "d"];
      let returnValue = true;
      const isRestrictedSchedule = restrictedSchedules.includes(ndaSchedule.toLowerCase());
      let packSizeHasDecimal;
      if (this.packSize == null) {
        packSizeHasDecimal = false
      } else {
        packSizeHasDecimal = this.packSize.toString().indexOf(".") >= 0;
      }
      if (this.ndcNumber.includes('**')) {
        console.log("NDC includes**")
        console.log("packSize", this.packSize)
        if (!this.packSize) {
          this.flashMessages.push({
            message: 'Pack Size is required',
            type: 'WARNING'
          });
          returnValue = false
        }
        if (!localUOM) {
          console.log("localUOM", localUOM)
          this.flashMessages.push({
            message: 'UoM is required',
            type: 'WARNING'
          });
          returnValue = false
        }
        if (/*this should be ordered quantity packsize * pack count*/this.packSize != null && this.packSize.length > 8) {
          this.flashMessages.push({
            message: 'Can\'t report more than 8 digits.',
            type: 'WARNING'
          });
          returnValue = false
        }
        let noDecimalUoMs = ['U',
          'K',
          'D',
          'u',
          'k',
          'd'];
        console.log("packsize", this.packSize)
        if (isRestrictedSchedule && packSizeHasDecimal && noDecimalUoMs.includes(localUOM.toLowerCase())) {
          this.flashMessages.push({
            message: `Pack size cannot contain decimal when reporting dosage form.`,
            type: 'WARNING'
          });
          returnValue = false
        }
        if ((localUOM.toLowerCase() === "ml" && packSizeHasDecimal && isRestrictedSchedule)) {
          this.flashMessages.push({
            message: 'Quantity Reporting In mL Cannot Be Entered With A Decimal.',
            type: 'WARNING'
          });
          returnValue = false
        }
      } else {
        if (packQuantity.toString().indexOf(".") >= 0) {
          this.flashMessages.push({
            message: 'Pack Quantity For Complete NDCs Cannot Be Entered With A Decimal.',
            type: 'WARNING'
          });
          returnValue = false
        }
      }
      console.log("Fields being validated return value", returnValue)
      console.log("FlashMessage length", this.flashMessages.length)
      return returnValue
    },
	},
	computed: {
		isBulk() {
			return this.ndcNumber && this.ndcNumber.includes('**')
		},
		orderedQtyCalc() {
			if (this.isBulk) {
				return !this.packSize || !this.packQuantity ? 0 : this.packSize * this.packQuantity
			} else {
				return this.packQuantity
			}
		}
	}
}
</script>

<style scoped>
>>> .modal-header {
    margin-top: 0.5em;
    color: rgb(131, 186, 35);
}

>>> .modal-footer {
    padding-bottom: 0.25em !important;
    padding-top: 0.25em !important;
}
</style>